import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import { Constants, Frontend_URL } from '../../shared/constants';
import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material';


const CarouselComponent = () => {

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
    const slides = [
        {
            image: Constants.customImages.CarouselImg,
            title: "Unlock Fun + Learning! Join our summer camp now",
            description: "Let your child explore summer camp activities with a difference. At MySkill, we provide learning spanning multiple disciplines with focus on holistic development of each child. We are now available in apartments also.",
            linearGradient: 'linear-gradient(272.54deg, rgba(65, 105, 225, 0) 2.05%, #4169E1 98.52%)'

        },
        // {
        //     image: Constants.customImages.CarouselImg1,
        //     title: "Join the Fun! Fancy Dress Competition 2025",
        //     description: "Don't miss out on this exciting course that’s designed to help you master UI/UX Designing. Start learning today, and unlock the potential to grow your knowledge and career",
        //     linearGradient: "linear-gradient(271.12deg, rgba(0, 0, 0, 0) 1.16%, #000000 100%)"
        // },
    ];

    return (
        <Swiper
            modules={[Pagination, Autoplay, EffectFade]}
            effect="fade"
            spaceBetween={10}
            slidesPerView={1}
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop
            allowTouchMove={false}
            style={{
                minHeight: "100%",
                borderRadius: "15px",
                position: "relative",

            }}
        >
            {slides.map((slide, index) => (
                <SwiperSlide key={index}>
                    <Box sx={{
                        position: "relative",
                        minHeight: "180px",
                        backgroundImage: `url(${slide.image})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        padding: { lg: "35px 42px", xs: "15px 10px" },
                        color: "white",
                        borderRadius: "15px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",

                    }}>
                        <div style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: slide.linearGradient,
                            borderRadius: "15px",

                        }} />
                        <div style={{ position: "relative" }}>
                            <Typography variant='h4' color='text.secondary' fontWeight={500} mb={1}>
                                {/* {isSmallScreen ? truncateText(slide.title, 6) : slide.title} */}
                                { slide.title}
                            </Typography>


                            <Typography variant='body2' sx={{ color: 'text.secondary', textAlign: "justify", display: "inline"}}>
                            
                                {/* {isSmallScreen ? truncateText(slide.description, 15) : truncateText(slide.description, 30)} */}
                                {slide.description}
                                {/* <Typography variant='h5' component="span" color='blue.main' sx={{ display: "inline", cursor: "pointer" }}>
                                    Read More
                                </Typography> */}
                            </Typography>
                        </div>

                        <Box sx={{ display: 'flex', gap: "10px" }}>
                            <Button variant='gost' onClick={() => { window.location.href = `${Frontend_URL}ContactUs`; }}>Contact Now</Button>
                            <Button variant='text' onClick={() => { window.location.href = `${Frontend_URL}Courses`; }}>Enroll Now</Button>
                        </Box>
                    </Box>
                </SwiperSlide>
            ))}
        </Swiper>
    );
};

export default CarouselComponent;
